import { NavbarData } from './sidenav.model';

export const navbarData: NavbarData[] = [
  {
    routeLink: '/partner/list',
    icon: `assets/images/nav-icon/address-book.svg`,
    label: 'Partners',
    hasAccess: false,
  },
  {
    routeLink: '/wallet/list',
    icon: `assets/images/nav-icon/wallet.svg`,
    label: 'Wallets',
    hasAccess: false,
  },
  {
    routeLink: '/transaction/list',
    icon: `assets/images/nav-icon/txn.svg`,
    label: 'Transactions',
    hasAccess: false,
  },
  {
    routeLink: '/sender/list',
    icon: `assets/images/nav-icon/sender.svg`,
    label: 'Senders',
    hasAccess: false,
  },
  {
    routeLink: '/recipient/list',
    icon: `assets/images/nav-icon/benef.svg`,
    label: 'Recipients',
    hasAccess: false,
  },
  {
    routeLink: '/master-settings',
    icon: `assets/images/nav-icon/setting.svg`,
    label: 'Global Settings',
    hasAccess: false,
    items: [
      {
        routeLink: '/master-settings/transaction-settings',
        label: 'Transaction Settings',
        hasAccess: false,
      },
      {
        routeLink: '/master-settings/adapter-settings',
        label: 'Adapter Settings',
        hasAccess: false,
      },
    ],
  },
  {
    routeLink: '/master-partner-settings',
    icon: `assets/images/nav-icon/user-cog.svg`,
    label: 'Partner Settings',
    hasAccess: false,
    items: [
      {
        routeLink: '/master-partner-settings/transaction-settings',
        label: 'Transaction Settings',
        hasAccess: false,
      },
      {
        routeLink: '/master-partner-settings/adapter-settings',
        label: 'Adapter Settings',
        hasAccess: false,
      },
    ],
  },
  {
    routeLink: '/settings',
    icon: `assets/images/nav-icon/setting.svg`,
    label: 'Settings',
    hasAccess: false,
    items: [
      {
        routeLink: '/settings/country',
        label: 'Countries',
        hasAccess: false,
      },
      {
        routeLink: '/settings/transaction-settings',
        label: 'Transaction Settings',
        hasAccess: false,
      },
      {
        routeLink: '/settings/velocity-limit/list',
        label: 'Velocity Limit',
        hasAccess: false,
      },
    ],
  },
  {
    routeLink: '/user-management',
    icon: `assets/images/nav-icon/user-management.svg`,
    label: 'User Management',
    hasAccess: false,
    items: [
      {
        routeLink: '/user-management/user/list',
        label: 'Users',
        hasAccess: false,
      },
      {
        routeLink: '/user-management/role/list',
        label: 'Roles',
        hasAccess: false,
      },
      {
        routeLink: '/user-management/permission/list',
        label: 'Permissions',
        hasAccess: false,
      },
    ],
  },
];
